import {useEffect, useState} from "react";

import VLFModal from "@/components/Modal";
import VLFTextField from "@/components/Input/TextField";
import VLFSelectNew from "@/components/Input/SelectNew";

import {REQUIRED_FIELD, videoTagTypeOptions} from "@/utils/constants";
import {checkRequiredFields, playerToOption} from "@/utils/functions";

const requiredFields = ["tagType", "minute"];

function HandleTagModal(props) {
	const {open, close, confirm, players, initialData} = props;

	const [formData, setFormData] = useState({minute: 0, second: 0});
	const [errors, setErrors] = useState([]);

	useEffect(() => {
		if (initialData) {
			setFormData({
				...initialData,
				tagType: videoTagTypeOptions.find((o) => o.value === initialData.tagType) || null,
				player: initialData.playerId && players?.length
					? players.map((p) => playerToOption(p)).find((o) => o.value === initialData.playerId)
					: null,
			});
		} else {
			setFormData({minute: 0, second: 0});
		}
	}, [initialData, players]);

	useEffect(() => {
		if (!open) {
			setFormData({minute: 0, second: 0});
			setErrors([]);
		}
	}, [open]);

	return (
		<VLFModal
			maxWidth="md"
			open={open}
			title={initialData ? "Modifica tag" : "Nuovo tag"}
			close={close}
			confirm={() => {
				const errs = checkRequiredFields(requiredFields, formData);
				setErrors(errs);
				if (errs.length) return;

				confirm(
					{
						tagType: formData.tagType?.value,
						tagLabel: formData.tagType?.label,
						minute: parseInt(formData.minute) || 0,
						second: parseInt(formData.second) || 0,
						playerId: formData.player?.value || null,
						playerName: formData.player?.label || null,
						notes: formData.notes || "",
					},
					initialData?.id,
				);
			}}
			content={
				<div className="row">
					<div className="col-xs-6 col-sm-3">
						<VLFTextField
							name="minute"
							value={formData.minute ?? ""}
							onChange={(e) => {
								setErrors([]);
								setFormData({...formData, minute: e.target.value});
							}}
							label="Minuto"
							size="small"
							type="number"
							required
							helperText={errors.indexOf("minute") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("minute") !== -1}
						/>
					</div>
					<div className="col-xs-6 col-sm-3">
						<VLFTextField
							name="second"
							value={formData.second ?? ""}
							onChange={(e) => {
								setFormData({...formData, second: e.target.value});
							}}
							label="Secondo"
							size="small"
							type="number"
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFSelectNew
							options={videoTagTypeOptions}
							sorted={false}
							value={formData.tagType || ""}
							onChange={(value) => {
								setErrors([]);
								setFormData({...formData, tagType: value});
							}}
							label="Tipo azione"
							required
							helperText={errors.indexOf("tagType") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("tagType") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFSelectNew
							options={players?.map((p) => playerToOption(p)) || []}
							sortKey="sortKey"
							isClearable
							value={formData.player || ""}
							onChange={(value) => {
								setFormData({...formData, player: value});
							}}
							label="Giocatore"
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="notes"
							value={formData.notes || ""}
							onChange={(e) => {
								setFormData({...formData, notes: e.target.value});
							}}
							label="Note"
							size="small"
						/>
					</div>
				</div>
			}
		/>
	);
}

export default HandleTagModal;
